export const formatDate = (dateStr) => {
	const dateObj = new Date(dateStr);
	if (isNaN(dateObj.getTime())) {
		return dateStr;
	}

	const twoDigit = (num) => num.toString().padStart(2, "0");
	const year = dateObj.getFullYear();
	const month = twoDigit(dateObj.getMonth() + 1);
	const day = twoDigit(dateObj.getDate());

	let hours = dateObj.getHours();
	const minutes = twoDigit(dateObj.getMinutes());
	const ampm = hours >= 12 ? "pm" : "am";
	hours = hours % 12;
	if (hours === 0) hours = 12;

	return `${day}/${month}/${year}\u00A0\u00A0\u00A0${hours}:${minutes} ${ampm}`;
};